import { Component, OnInit, Inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LocalStorageService } from 'ngx-webstorage';
import { ConsumerClaimantsModel } from '../../../models/consumerclaimantsmodel';

@Component({
  selector: 'app-consumer-complete',
  templateUrl: './consumer-complete.html',
  styleUrls: ['./consumer-complete.css'],
  imports: [DatePipe], // Add this using the DatePipe Directive in the template
})
export class ConsumerComplete implements OnInit {
  claimant: ConsumerClaimantsModel;

  constructor(
    private storage: LocalStorageService,
  ) { }

  ngOnInit() {
    this.claimant = this.storage.retrieve('claimant');
  }
}
